import moment from 'moment/moment';
import html2canvas from 'html2canvas';

import {
    IMAGE_UPLOAD_STATUS_FAILED,
    IMAGE_UPLOAD_STATUS_UPLOADED,
    IMAGE_UPLOAD_STATUS_UPLOADING,
    IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD,
} from "../shared/redux/constants"

const scrollTo = (position = 0,behavior = 'smooth') => {
    window.scrollTo({
        top: position,
        behavior: behavior
    });
}

const IMAGE_STATUS_PRIORITY = {
    [IMAGE_UPLOAD_STATUS_FAILED]: 1,
    [IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD]: 2,
    [IMAGE_UPLOAD_STATUS_UPLOADING]: 3,
    [IMAGE_UPLOAD_STATUS_UPLOADED]: 4
};

const getLastLegalDays = (dateAfter10, vacationDays) => {
    let totalDays = 0;
    const dateAfter10Days = moment(dateAfter10);
    let lastLegalDay = dateAfter10Days;
    vacationDays.forEach((vacationDaysItem) => {
        const vacationStart = moment(vacationDaysItem.start);
        const vacationEnd = moment(vacationDaysItem.end);
        if (dateAfter10Days.isBetween(vacationStart, vacationEnd, 'days', '[]') || vacationStart.isBetween(moment(), moment(dateAfter10Days, 'days', '[]')) || vacationEnd.isBetween(moment(), moment(dateAfter10Days, 'days', '[]'))) {
            const countVacationDays = moment(vacationEnd).businessDiff(moment(vacationStart));
            totalDays = totalDays + countVacationDays;
            lastLegalDay = moment().businessAdd(9 + totalDays, 'days').toDate();
        }
    })
    return lastLegalDay;
}


const defaultToEmptyString = (prop) => prop == null ? '' : prop;


const findBusinessDays = (vacationDays, returnDate, numberOfDays = 8) => {
    let resultDates = [];

    let currentDate = moment(returnDate);
    while (resultDates.length < numberOfDays) {
        if (!isNonWorkingDay(currentDate, vacationDays)) {
            resultDates.push(currentDate.format('YYYY-MM-DD'));
        }
        currentDate = currentDate.subtract(1, 'days');
    }
    return resultDates;
};

const is8BusinessDayBeforeReturnDate = (date,eightBusinessDays= []) => eightBusinessDays.length ? eightBusinessDays.includes(date.format("YYYY-MM-DD")) : Boolean(eightBusinessDays.length);

const isNonWorkingDay = (date,vacationDays) => {
    let isVacationDay = false;
    const dateWithoutTime = resetDateTime(new Date(date));
    vacationDays && vacationDays.forEach((item)=>{
        if(resetDateTime(new Date(item.start)) <= dateWithoutTime && dateWithoutTime <= resetDateTime(new Date(item.end))){
            isVacationDay = true;
        }
    })
    return moment(date).day() === 0 || moment(date).day() === 6 || isVacationDay;
}

const getNext8BusinessDays = (vacationDays) => {
    const businessDays = [];
    let currentDate = moment().startOf('day');

    while (businessDays.length < 8) {
        if (!isNonWorkingDay(currentDate.toDate(), vacationDays)) {
            businessDays.push(currentDate.format('YYYY-MM-DD'));
        }
        currentDate.add(1, 'day');
    }

    return businessDays;
}

function canvasToBlob(canvas, mimeType = 'image/png') {
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error('Canvas is empty'));
            }
        }, mimeType);
    });
}

function resetDateTime(date) {
    return date.setHours(0,0,0,0);
}

const takeScreenShot = async (node) => {
    const canvas = await html2canvas(node);
    const blob = await canvasToBlob(canvas);
    const dataURI = canvas.toDataURL();
    return { dataURI, blob }
};


const getMiliseconds = (value, type = 'day') => {
    switch(type) {
        case 'day': {
            return value * 24 * 3600 * 1000;
        }
        case 'hour': {
            return value * 3600 * 1000;
        }
    }
}

const getCurrentTimeStamp = () => new Date().getTime().toString();

const formatDate = (startOrEnd,date) => moment(date)[startOrEnd === 'start' ? 'startOf' : 'endOf']('month')[startOrEnd === 'start' ? 'startOf' : 'endOf']('week').format('YYYY-MM-DD');

const sortImagesByStatus = (a,b) => {
    return (IMAGE_STATUS_PRIORITY[a.status] || 999) - (IMAGE_STATUS_PRIORITY[b.status] || 999);
}

export {
    sortImagesByStatus,
    formatDate,
    scrollTo,
    isNonWorkingDay,
    resetDateTime,
    takeScreenShot,
    getMiliseconds,
    getLastLegalDays,
    getCurrentTimeStamp,
    defaultToEmptyString,
    findBusinessDays,
    is8BusinessDayBeforeReturnDate,
    getNext8BusinessDays
}



// WEBPACK FOOTER //
// ./src/helpers/index.js